import React, { useEffect, useState } from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoadingScreen from "./components/LoadingScreen";
import AppShell from "./components/layout/AppShell";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Home from "./pages/Home";
import Signals from "./pages/Signals";
import Journal from "./pages/Journal";
import RiskManagement from "./pages/RiskManagement";
import DailyLesson from "./pages/DailyLesson";
import Leaderboard from "./pages/Leaderboard";
import Giveaway from "./pages/Giveaway";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

function ProtectedLayout() {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  return <Navigate to={user ? "/home" : "/login"} replace />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/home" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/signals" element={<Signals />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/risk-management" element={<RiskManagement />} />
        <Route path="/daily-lesson" element={<DailyLesson />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/giveaway" element={<Giveaway />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  const [booting, setBooting] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setBooting(false), 1000);
    return () => clearTimeout(t);
  }, []);

  if (booting) return <LoadingScreen />;

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
